import { Box, Container, Typography } from "@mui/material";
import React from "react";
import bear from "../../assets/bear.jpg";
import { Helmet } from "react-helmet-async";
export default function NotFound() {
    return (
        <>
            <Helmet>
                <title>404 Not found</title>
            </Helmet>
            <Box
                textAlign={"center"}
                color={"primary.contrastText"}
                margin={1}
                padding={5}
            >
                <Typography variant="h1">404</Typography>
                <Typography variant="h4">
                    Oi that page does not exist. Try checking the url
                </Typography>
            </Box>
            <Container style={{ alignItems: "center" }} maxWidth="md">
                <img
                    src={bear}
                    style={{ maxWidth: "100%", borderRadius: 5 }}
                ></img>
            </Container>
        </>
    );
}
